/******/ (() => { // webpackBootstrap
/*!****************************************!*\
  !*** ./src/js/pages/brand-mephisto.js ***!
  \****************************************/
document.addEventListener("DOMContentLoaded", function () {
  // Automatically activate the first outer tab
  var firstTab = document.querySelector(".tab-link");
  if (firstTab) {
    firstTab.click();
  }
});

// Function for opening outer tabs
window.openTab = function (evt, tabName) {
  var i, tabContent, tabLinks;
  tabContent = document.getElementsByClassName("tab-content");
  for (i = 0; i < tabContent.length; i++) {
    tabContent[i].style.display = "none";
  }
  tabLinks = document.getElementsByClassName("tab-link");
  for (i = 0; i < tabLinks.length; i++) {
    tabLinks[i].classList.remove("active");
  }
  var activeTab = document.getElementById(tabName);
  if (activeTab) {
    activeTab.style.display = "block";
    evt.currentTarget.classList.add("active");

    // Automatically activate the first inner tab of this active tab
    var firstInnerTab = activeTab.querySelector(".inner-tab-link");
    if (firstInnerTab) {
      firstInnerTab.click();
    }
  }
};

// Function for opening inner tabs
window.openInnerTab = function (evt, innerTabName) {
  var i, innerTabContent, innerTabLinks;
  innerTabContent = document.getElementsByClassName("inner-tab-content");
  for (i = 0; i < innerTabContent.length; i++) {
    innerTabContent[i].style.display = "none";
  }
  innerTabLinks = document.getElementsByClassName("inner-tab-link");
  for (i = 0; i < innerTabLinks.length; i++) {
    innerTabLinks[i].classList.remove("active");
  }
  document.getElementById(innerTabName).style.display = "block";
  evt.currentTarget.classList.add("active");
};
window.addEventListener("scroll", function () {
  var sticky = document.querySelector("#shopify-section-header");
  var scroll = window.scrollY;
  if (scroll >= 100) {
    sticky.classList.add("fixed");
  } else {
    sticky.classList.remove("fixed");
  }
});
/******/ })()
;